import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Llegaba los lunes sin nada preparado. Ahora tengo todo listo desde el viernes. Mis alumnos mejoraron y yo llego descansada al aula.',
  author: 'Mariela G.',
  role: 'docente de 2º grado, Buenos Aires'
}, {
  quote: 'En la primera reunión de padres pude mostrar el progreso de cada chico con datos concretos. La directora quedó impresionada.',
  author: 'Valeria T.',
  role: 'docente de 4º grado, Córdoba'
}, {
  quote: 'Los textos son hermosos y los chicos me piden que les lea más. No puedo creer que cueste tan poco por todo lo que trae.',
  author: 'Claudia M.',
  role: 'docente de 3º grado, Rosario'
}, {
  quote: 'El Kit de Emergencia fue lo que más usé. Siempre tenés algo para dar aunque el día se haya puesto de costado.',
  author: 'Sandra P.',
  role: 'docente de 5º grado, Mendoza'
}, {
  quote: 'Soy maestra hace 12 años y nunca tuve un material tan completo. Mis nenas de primero ya reconocen palabras que antes no podían. Y yo recuperé mis tardes libres.',
  author: 'Luciana R.',
  role: 'docente de 1º grado, Tucumán'
}];
export function TestimonialsSection() {
  return <section className="py-20 bg-white" data-id="element-349">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-350">
        <div className="text-center mb-16" data-id="element-351">
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#1E3A5F] mb-4" data-id="element-352">
            LO QUE DICEN MAESTRAS QUE YA LO USAN
          </h2>
          <div className="w-24 h-1.5 bg-[#16A34A] mx-auto rounded-full" data-id="element-353"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-354">
          {testimonials.map((testimonial, index) => <div key={index} className={`bg-slate-50 p-8 rounded-3xl border border-slate-200 shadow-sm hover:shadow-md transition-shadow ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-355">
              <div className="flex mb-4" data-id="element-356">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-[#F59E0B] fill-current" data-id="element-357" />)}
              </div>
              <p className="text-slate-700 italic mb-6 text-lg" data-id="element-358">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center" data-id="element-359">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center text-[#1E3A5F] font-bold text-xl mr-4" data-id="element-360">
                  {testimonial.author.charAt(0)}
                </div>
                <div data-id="element-361">
                  <p className="font-bold text-[#1E3A5F]" data-id="element-362">
                    {testimonial.author}
                  </p>
                  <p className="text-sm text-slate-500" data-id="element-363">{testimonial.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}